import { useEffect } from "react";

import TemplateAnimation from "./Components/Common/TemplateAnimation";
import DataLandingPage from "./Data/DataLandingPage";

import connectWithDispatch from "src/Hooks/connectWithDispatch";
import { TO_WORKFLOW } from "./Data/TURF_OPTIMIZATION";
import RESPONSIBLE_AI from "./Data/RESPONSIBLE_AI";
import TRANSFOMER_WORKFLOW from "./Data/TRANSFORMER";
import STS_WORKFLOW from "./Data/SOUND_TO_SIGHT";

import * as appActions from "src/Actions/appActions";

interface AppProps {
  currentPage: number;
  setCurrentPage: (value: number) => void;
  param?: string;
}

const App = (props: AppProps) => {
  const { currentPage, setCurrentPage, param = "" } = props;

  const templates = [
    {
      page: 1,
      type: "landing-page-template" as TemplateType,
      data: DataLandingPage,
    },
    ...RESPONSIBLE_AI,
    ...TO_WORKFLOW,
    ...STS_WORKFLOW,
    ...TRANSFOMER_WORKFLOW,
  ];

  useEffect(() => {
    if (param === "sound_to_sight") setCurrentPage(101);
    if (param === "transformer") setCurrentPage(201);
  }, [param, setCurrentPage]);

  return (
    <>
      <TemplateAnimation currentPage={currentPage} templates={templates} />
    </>
  );
};

const mapStateToProps = (state: StateType) => {
  return {
    currentPage: state.appReducer.currentPage,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setCurrentPage: appActions.setCurrentPage,
};

export default connectWithDispatch(App, mapStateToProps, mapDispatchToProps);
